module.exports = __webpack_public_path__ + "static/img/footer-logo-1.de2e327c.png";